// src/features/services/components/ServiceList.tsx
import type { Service } from './ServiceRow';
import { ServiceRow } from './ServiceRow';

interface ServiceListProps {
  services: Service[];
  /** id of the service currently open in the Service Workspace, if any */
  selectedServiceId?: string | null;
  /** called when a row is chosen to open the Service Workspace */
  onSelectService?: ((service: Service) => void) | undefined;
}

export function ServiceList({ services, selectedServiceId = null, onSelectService }: ServiceListProps) {
  if (services.length === 0) {
    return (
      <p className="px-5 py-6 text-center text-sm text-[var(--vania-colors-text-secondary,#a3aab8)]">
        سرویسی یافت نشد.
      </p>
    );
  }

  return (
    <div className="divide-y divide-[var(--vania-colors-border-subtle,rgba(255,255,255,0.08))]">
      {services.map((service) => (
        <ServiceRow
          key={service.id}
          service={service}
          isSelected={service.id === selectedServiceId}
          onSelect={onSelectService}
        />
      ))}
    </div>
  );
}
